import { ParentComponent } from 'solid-js';
import styles from './ValidationError.module.scss';

export const ValidationError: ParentComponent = props => {
  return <div class={styles.error}>{props.children}</div>;
};
